import { Delete, Settings } from '@mui/icons-material';
import { styled, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

export const Wrapper = styled('div')(({ theme }) => ({
  width: '100%',
  height: '100%',
  minWidth: '250px',
  display: 'flex',
  alignItems: 'center',
  whiteSpace: 'nowrap',
  backgroundColor: theme.palette.background.paper,
  borderRadius: '8px',
  border: `1px solid ${theme.palette.grey[200]}`,
  padding: '12px 16px',
  gap: '16px',
}));

export const IconWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '8px',
  width: '36px',
  height: '36px',
  padding: '0 10px',
  backgroundColor: theme.palette.grey[100],
  '& > .MuiSvgIcon-root': {
    color: theme.palette.text.primary,
    width: '18px',
    height: '18px',
  },
}));

export const Content = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingInline: '12px',
  width: '100%',
  gap: '8px',
  flexGrow: 1,
  minWidth: 0,
}));

export const TitleWrapper = styled('div')({
  flex: 1,
  minWidth: 0,
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  '& > .MuiTypography-root': {
    flex: 1,
    minWidth: 0,
  },
});

export const Title = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  display: 'block',
}));

export const Actions = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  height: '32px',
  gap: '8px',
}));

export const StyledLink = styled(Link)(() => ({
  textDecoration: 'none',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  minWidth: 0,
}));

export const StyledAnchor = styled('a')(() => ({
  textDecoration: 'none',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  minWidth: 0,
}));

export const StyledSettings = styled(Settings)(({ theme }) => ({
  color: theme.palette.text.primary,
  cursor: 'pointer',
  transition: theme.transitions.create('transform'),
  '&:hover': {
    transform: 'scale(1.1)',
  },
}));

export const StyledRemove = styled(Delete)(({ theme }) => ({
  color: theme.palette.text.primary,
  cursor: 'pointer',
  transition: theme.transitions.create('transform'),
  '&:hover': {
    transform: 'scale(1.1)',
  },
}));

export const StyledLinkButtonWrapper = styled('div')(({ theme }) => ({
  width: '34px',
  height: '34px',
  borderRadius: '8px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: theme?.palette.grey[100],
  cursor: 'pointer',
  '& > button > svg': {
    fill: theme?.palette.primary.main,
  },
  [theme!.breakpoints.down('md')]: {
    width: '28px',
    height: '28px',
  },
}));
